import { Hero } from "../components/site/Hero";
import { TrustStrip } from "../components/site/TrustStrip";
import { AboutTeaser } from "../components/site/AboutTeaser";
import { WhatWeDo } from "../components/site/WhatWeDo";
import { CTABand } from "../components/site/CTABand";

export default function Home() {
  return (
    <>
      <Hero />
      <TrustStrip />
      <AboutTeaser />
      <WhatWeDo />
      <CTABand />
    </>
  );
}
